// src/stores/profilStore.ts
import { create } from "zustand";
import { ServiceContainer } from "@/core/di";
import { StringsKeys } from "@/core/internationalization/strings";
import Exception from "@/core/exceptions/Exception";
import ExceptionService from "@/core/exceptions/exceptionService/ExceptionService";
import DefaultExceptionTypes from "@/core/exceptions/DefaultExceptionTypes";
import {
  CustomerProfilData,
  CustomerProfilResponse,
} from "../customers/entities";
import {
  createDefaultCustomerProfilData,
  createDefaultCustomerProfilResponse,
} from "../customers/entities/defaults";
import GetCustomerProfilUseCase from "../client/useCases/CustomerProfilUseCase/CustomerProfilUseCase";

interface CustomerProfilState {
  data: CustomerProfilResponse;
  profil: CustomerProfilData | null;
  setProfil: (profil: CustomerProfilData) => void;
  updateProfil: (profil: CustomerProfilData) => void;
  loading: boolean;
  failedFetchingCustomerProfilException: Exception | null;
  setFailedFetchingProfilException: (
    failedFetchingCustomerProfilException: Exception | null
  ) => void;
  fetchProfil: (
    translate: (key: StringsKeys) => string,
    businessKey: string
  ) => Promise<void>;
}

const sc = ServiceContainer.getInstance();
const customerProfilRepository = sc.getRepository("customerProfil");

export const useCustomerProfilStore = create<CustomerProfilState>((set) => ({
  data: createDefaultCustomerProfilResponse(),
  profil: createDefaultCustomerProfilData(),
  setProfil: (profil) => set({ profil }),
  updateProfil: (profil) => set({ profil }),
  loading: false,
  failedFetchingCustomerProfilException: null,
  setFailedFetchingProfilException: (failedFetchingCustomerProfilException) =>
    set({ failedFetchingCustomerProfilException }),
  fetchProfil: async (translate, businessKey) => {
    // console.log("fetchProfil ===>", businessKey);
    try {
      set({ loading: true });

      const item = await new GetCustomerProfilUseCase(
        customerProfilRepository
      ).execute(businessKey);
      console.log("item", item);

      set({
        data: item,
        profil: item?.data,
        failedFetchingCustomerProfilException: null,
      });
    } catch (error) {
      console.log("error ===>", error);

      console.error("Erreur lors du chargement des clients :", error);

      const failedFetchingCustomerProfilException =
        ExceptionService.handleException<undefined, DefaultExceptionTypes>(
          error as Exception<undefined, DefaultExceptionTypes>,
          translate,
          (exceptionType: DefaultExceptionTypes) => {
            if (exceptionType === DefaultExceptionTypes.NETWORK_ERROR) {
              return translate(StringsKeys.networkError);
            }
            return null;
          }
        );

      set({
        profil: null,
        failedFetchingCustomerProfilException,
      });
    } finally {
      set({ loading: false });
    }
  },
}));
